import SliderV1 from "@/components/catalog/sliders/SliderV1.vue";
import SliderV2 from "@/components/catalog/sliders/SliderV2.vue";
import SliderV3 from "@/components/catalog/sliders/SliderV3.vue";
import SliderV4 from "@/components/catalog/sliders/SliderV4.vue";
import SliderV5 from "@/components/catalog/sliders/SliderV5.vue";
import SliderV6 from "@/components/catalog/sliders/SliderV6.vue";
import SliderV7 from "@/components/catalog/sliders/SliderV7.vue";
import SliderV8 from "@/components/catalog/sliders/SliderV8.vue";
import SliderV9 from "@/components/catalog/sliders/SliderV9.vue";
import SliderV10 from "@/components/catalog/sliders/SliderV10.vue";
import SliderV11 from "@/components/catalog/sliders/SliderV11.vue";
import SliderV12 from "@/components/catalog/sliders/SliderV12.vue";

export const sliderComponents = {
    v1: SliderV1,
    v2: SliderV2,
    v3: SliderV3,
    v4: SliderV4,
    v5: SliderV5,
    v6: SliderV6,
    v7: SliderV7,
    v8: SliderV8,
    v9: SliderV9,
    v10: SliderV10,
    v11: SliderV11,
    v12: SliderV12
};

export const sliderVariantOptions = [
    { value: "v1", label: "Fila centrada" },
    { value: "v2", label: "Envolvente centrada" },
    { value: "v3", label: "Envolvente compacta" },
    { value: "v4", label: "Scroll horizontal" },
    { value: "v5", label: "Envolvente espaciada" },
    { value: "v6", label: "Envolvente amplia" },
    { value: "v7", label: "Grid hero" },
    { value: "v8", label: "Carrusel con flechas" },
    { value: "v9", label: "Grid asimétrico" },
    { value: "v10", label: "Destacado + grid" },
    { value: "v11", label: "Coverflow con miniaturas" },
    { value: "v12", label: "Carrusel amplio" }
];

export const DEFAULT_SLIDER_VARIANT = "v1";

// Nivel de alto de tarjeta de cada estilo. Mismos valores que
// `sliderSizeTiers` en catalog (slider-map.ts); lo compara
// scripts/check-segment-parity.sh del harness.
export const sliderSizeTiers = {
    v1: "sm",
    v2: "sm",
    v3: "sm",
    v8: "sm",
    v4: "md",
    v5: "md",
    v6: "md",
    v7: "md",
    v11: "md",
    v9: "lg",
    v10: "lg",
    v12: "lg"
};

export const SLIDER_SIZE_TIER_OPTIONS = [
    { value: "sm", label: "Tarjetas chicas" },
    { value: "md", label: "Tarjetas medianas" },
    { value: "lg", label: "Tarjetas grandes" }
];
